import React from 'react'

const PageHeadline = ({ title }) => {
    return (
        <p className='quizRHeadText font-bold text-36 pt-4 md:pt-10 lg:pt-16 pb-4 md:pb-8 lg:pb-12'>{title}</p>
    )
}

export default PageHeadline
